import type { FaireProductEntity } from "../../entity_types/product";

export const p_m2ats3qwmc: FaireProductEntity = {
  token: "p_m2ats3qwmc",
  type: "product",
  name: "Ref: 33 BABY BOOTIES 100% PEARL ( SPRING / SUMMER )",
  brandToken: "b_gvnnnu5bqh",
  brandName: "Cotton Socks",
  imageUrl:
    "https://cdn.faire.com/fastly/3acb8a2fa7914eefc99a642a0353d926d927da3f5d96f62445715a784c24ced1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7cbc82232728e8b4b93e39965a248d36e49f3c97fcc43f7d9540b2de6f79a10.jpeg",
  ],
  priceDollars: 1.27,
  description:
    "About Cotton Socks\n\nAt Cotton Socks, we take care of every detail to offer garments that guarantee a comfortable and secure fit for your baby. Our clothes are carefully designed to keep up with the growth of the little ones, allowing them to explore the world with freedom and joy.\n\nWe know that life with a baby can be full of challenges, so we created practical and easy-care clothes. All parts are washable and ready to be reused quickly, without compromising on quality.\n\nCotton Socks is the perfect combination of caress, comfort and durability for your baby's day to day. With us, your baby's well-being is always in the first place.",
  tags: [],
  msrpDollars: 2.55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:04.474Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
